import { createSlice } from "@reduxjs/toolkit";
import {manageConfiguratorState} from "../configuratorStateSlice";
import APIService from "../../configurator/services/APIService";
import {selectionsSelectionsClear} from "../product/productSelectionsSlice";

export const projectDetailsSlice =  createSlice({
    name: 'products',
    initialState: {
        detailsLoading: 'idle',
        projectName: "",
        projectType: "",
        projectCreatedAt: "",
        currency: "USD",
        priceBook: "",
        language: 'English',
        country: '',
        priceTerms: '',
        agencyCommissionPercent: 0,
        agencyOveragePercent: 0,
        freightTerms: '',
        quantity: "",
        lineNumber: "",
        quoteId: "",
        quoteItemId: "",
        elementGroupId: "",
        quoteItems: [],
        productID: "",
        categoryID: "",
    },
    reducers: {
        projectDetailsLoading(state ,action){
            if(state.detailsLoading == 'idle'){
                state.detailsLoading = 'pending'
            }
        },
        projectNameSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.projectName = action.payload
            }
        },
        projectTypeSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.projectType = action.payload
            }
        },
        projectCreatedAtSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.projectCreatedAt = action.payload
            }
        },
        currencySet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.currency = action.payload
            }
        },
        quoteIdSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.quoteId = action.payload
            }
        },
        quoteItemsSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.quoteItems = action.payload
            }
        },
        quantitySet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.quantity = action.payload;
            }
        },
        lineNumberSet(state, action) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.lineNumber = action.payload
            }
        },
        quoteItemIdSet(state, action ) {
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.quoteItemId = action.payload
            }
        },
        productIdSet(state, action){
            if(state.detailsLoading == 'pending'){
                state.detailsLoading = 'idle';
                state.productID = action.payload;
            }
        },
        categoryIdSet(state, action){
            state.categoryID = action.payload;
        },
        setElementGroupId(state, action){
            state.elementGroupId = action.payload;
        },
        setPriceBook(state, action) {
            state.priceBook = action.payload;
        },
        setLanguage(state, action) {
            state.language = action.payload;
        },
        setAgencyDetails(state, action) {
            state.language = action.payload.language;
            state.country = action.payload.country;
            state.priceBook = action.payload.price_book ? action.payload.price_book : action.payload.currency;
            state.priceTerms = action.payload.price_terms;
            state.commissionPercent = action.payload.commission_percent;
            state.overageCommissionPercent = action.payload.overage_commission_percent;
            state.freightTerms = action.payload.freight_terms;
        }
    }
});
export const { projectDetailsLoading, quantitySet, lineNumberSet, projectNameSet, projectCreatedAtSet, projectTypeSet, currencySet, quoteIdSet, quoteItemsSet, quoteItemIdSet, productIdSet, categoryIdSet, setElementGroupId , setPriceBook, setLanguage, setAgencyDetails} = projectDetailsSlice.actions;

export const setProjectName = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(projectNameSet(value));
}

export const setProjectType = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(projectTypeSet(value));
}

export const setCreatedAt = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(projectCreatedAtSet(value));
}

export const setCurrency = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(currencySet(value));
}

export const setQuoteId = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(quoteIdSet(value));
}

export const setQuoteItems = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(quoteItemsSet(value));
}

export const setQuantity = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(quantitySet(value));
    dispatch(manageConfiguratorState())
}

export const setLineNumber = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(lineNumberSet(value));
}

export const setQuoteItemId = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(quoteItemIdSet(value));
}

export const setProductIdDetails = (value) => dispatch => {
    dispatch(projectDetailsLoading());
    dispatch(productIdSet(value));
}
/**
 * @description Updates the line number to the highest possible value based on
 * other quote items, then updates the store correspondingly.
 */
export const setLineNumberForNewQuoteItem = () => async (dispatch, getState) => {
    const quoteId = getState().projectDetailsReducer.quoteId;
    await dispatch(getQuoteData(quoteId));
    let quoteItems = Object.assign([], getState().projectDetailsReducer.quoteItems);
     quoteItems = quoteItems.sort((a,b) => b.line_number - a.line_number);
    const newLineNumber = quoteItems[0].line_number + 1;
    dispatch(setLineNumber(newLineNumber));
}

export const getQuoteData = (quoteId) => async(dispatch, getState) => {
    const data = await APIService.get_quote(quoteId);
    if(data) {
        // set all values
        dispatch(setProjectName(data.project_name));
        dispatch(setCreatedAt(data.project_created_at));
        // these are needed to validate if catalog number already exist
        dispatch(setQuoteItems(data.quote_items));
        const agencyParams = paramsFromQuoteOrAgency(data)
        dispatch(setAgencyParams(agencyParams))

    } else {
        dispatch(selectionsSelectionsClear());
        dispatch({type: 'ADD_NOTICE', notice_type: 'catalog_number', message: 'Having Trouble Fetching This Quote... Please Contact Administrator'})
        $('#configurator_main').find('input, textarea, button, select').attr('disabled','disabled'); // disable all fields
    }
}

/***
 * Helper function to grab agency params from quote if they exist, or resolve to agency defauls
 */
const paramsFromQuoteOrAgency = (data) => {
    const agency = data.agency;
    return {
        currency: data.currency_code ? data.currency_code : agency.default_currency_code,
        country: data.country ? data.country : agency.default_country,
        language: data.language ? data.language : agency.default_language,
        price_book: data.price_book ? data.price_book : agency.default_price_book,
        price_terms: data.price_terms ? data.price_terms : agency.default_price_terms,
        commission_percent: data.commission_percent ? data.commission_percent : agency.default_commission_percentage,
        overage_commission_percent: data.overage_commission_percent ? data.overage_commission_percent : agency.defualt_overage_percentage,
        freight_terms: data.freight_terms ? data.freight_terms : agency.default_freight_terms
    }

}
/***
 * Sets currency, pricebook and language attributes based on agency data
 */
export const setAgencyParams = (agency) => (dispatch, getState) => {
    dispatch(setCurrency(agency.currency))
    dispatch(setAgencyDetails(agency))
}


const reducer = projectDetailsSlice.reducer;
export default reducer
